/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetMathAssessmentsAssessmentAnswersR200ResponseInnerStandardFromJSON, GetMathAssessmentsAssessmentAnswersR200ResponseInnerStandardToJSON, } from './GetMathAssessmentsAssessmentAnswersR200ResponseInnerStandard';
/**
 * @export
 */
export const GetCourseElaAdaptiveSkillsAdaptiveProgressesR200ResponseInnerStatsInnerCurrentDataSourceEnum = {
    Map: 'map',
    Star: 'star',
    Manual: 'manual',
    FastBridge: 'fast_bridge'
};
/**
 * Check if a given object implements the GetCourseElaAdaptiveSkillsAdaptiveProgressesR200ResponseInnerStatsInnerCurrentData interface.
 */
export function instanceOfGetCourseElaAdaptiveSkillsAdaptiveProgressesR200ResponseInnerStatsInnerCurrentData(value) {
    if (!('level' in value) || value['level'] === undefined)
        return false;
    if (!('progressInDomainInGrade' in value) || value['progressInDomainInGrade'] === undefined)
        return false;
    if (!('standard' in value) || value['standard'] === undefined)
        return false;
    return true;
}
export function GetCourseElaAdaptiveSkillsAdaptiveProgressesR200ResponseInnerStatsInnerCurrentDataFromJSON(json) {
    return GetCourseElaAdaptiveSkillsAdaptiveProgressesR200ResponseInnerStatsInnerCurrentDataFromJSONTyped(json, false);
}
export function GetCourseElaAdaptiveSkillsAdaptiveProgressesR200ResponseInnerStatsInnerCurrentDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'level': json['level'],
        'progressInDomainInGrade': json['progressInDomainInGrade'],
        'source': json['source'] == null ? undefined : json['source'],
        'standard': GetMathAssessmentsAssessmentAnswersR200ResponseInnerStandardFromJSON(json['standard']),
    };
}
export function GetCourseElaAdaptiveSkillsAdaptiveProgressesR200ResponseInnerStatsInnerCurrentDataToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'level': value['level'],
        'progressInDomainInGrade': value['progressInDomainInGrade'],
        'source': value['source'],
        'standard': GetMathAssessmentsAssessmentAnswersR200ResponseInnerStandardToJSON(value['standard']),
    };
}
